import React from 'react';
import { ServiceItem } from '../../types/cabinet.types';
import { useI18n } from '../../hooks/useI18n';

interface ServiceCardProps {
  service: ServiceItem;
  onClick?: () => void;
  className?: string;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ service, onClick, className = '' }) => {
  const { t } = useI18n();
  const isZiolo = service.id === 'ziolo24';

  return (
    <div 
      className={`cab-svc-card ${isZiolo ? 'cab-svc-card--ziolo' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="cab-svc-ic">
        {service.icon}
      </div>
      <div className="cab-svc-content">
        <h4>{service.title}</h4>
        <p dangerouslySetInnerHTML={{ __html: service.description }}></p>
      </div>
      <div className="cab-svc-arrow">
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 13L7 7L1 1" stroke="#362C4E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      
      <style>{`
        .cab-svc-card {
          display: flex;
          align-items: center;
          gap: 16px;
          cursor: pointer;
          background: #FFFFFF;
          border-radius: 16px;
          padding: 14px 16px;
          box-shadow: 0px 2px 10px rgba(54, 23, 119, 0.04);
          border: 1px solid rgba(54, 23, 119, 0.02);
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .cab-svc-card:hover {
          transform: translateY(-2px);
          box-shadow: 0px 4px 12px rgba(54, 23, 119, 0.05);
        }
        .cab-svc-ic {
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: transparent;
        }
        .cab-svc-ic svg {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }
        .cab-svc-ic img {
          width: 44px;
          height: auto;
          max-height: 24px;
          object-fit: contain;
        }
        .cab-svc-content {
          flex-grow: 1;
        }
        .cab-svc-content h4 {
          font-size: 16px;
          color: #2F116A;
          margin: 0 0 4px 0;
          font-weight: 700;
          line-height: 1.2;
        }
        .cab-svc-content p {
          font-size: 13px;
          color: #2F116A;
          line-height: 1.4;
          margin: 0;
          font-weight: 400;
        }
        .cab-svc-content p strong {
          font-weight: 700;
          color: #2F116A;
        }
        /* Mobile: без кнопок і стрілок */
        .cab-svc-arrow {
          display: none;
        }
        .cab-svc-btn {
          display: none;
        }

        /* --- Ziolo24 Cross-sell specific card styling on Mobile (гармонійно з іншими: лого зліва) --- */
        .cab-svc-card--ziolo {
          gap: 10px;
        }
        .cab-svc-card--ziolo .cab-svc-ic {
          width: 44px;
          height: 32px;
        }
        .cab-svc-card--ziolo .cab-svc-ic img {
          width: 44px;
          height: auto;
          max-height: 24px;
          object-fit: contain;
        }

        /* Tablet and Desktop specific styles: стрілка як в інших, без кнопок */
        @media (min-width: 1024px) {
          .cab-svc-card {
            padding: 12px;
            gap: 20px;
            border-radius: 20px;
            box-shadow: none;
          }
          .cab-svc-ic {
            width: 80px;
            height: 80px;
            background: #F8F6FB;
            border-radius: 20px;
          }
          .cab-svc-ic img {
            width: 54px;
            height: auto;
            max-height: 36px;
          }
          .cab-svc-arrow {
            display: flex !important;
            flex-shrink: 0;
            align-items: center;
            justify-content: center;
            margin-left: 8px;
            margin-right: 8px;
          }
          .cab-svc-btn {
            display: none !important;
          }
          .cab-svc-content h4 {
            font-size: 16px;
          }
          .cab-svc-content p {
            font-size: 13px;
          }

          /* Desktop styling for Ziolo24 — в одному стилі, стрілка як в інших */
          .cab-svc-card--ziolo {
            gap: 20px !important;
          }
          .cab-svc-card--ziolo .cab-svc-ic {
            width: 80px !important;
            height: 80px !important;
          }
          .cab-svc-card--ziolo .cab-svc-ic img {
            width: 54px !important;
            height: auto !important;
            max-height: 36px !important;
          }
          .cab-svc-card--ziolo .cab-svc-arrow {
            display: flex !important;
          }
        }
      `}</style>
    </div>
  );
};
